// ── API data → ProductCard props ──────────────────────────────────────────────
export function normalizeProduct(item) {
  const price = item?.price ?? 0;
  const mrp   = item?.mrp   ?? 0;

  return {
    _id:           item?._id,           // ⬅️ yeh add karo
    id:            item?.slug || item?._id,
    name:          item?.title,
    craft:         item?.category || item?.brand || null,
    price,
    originalPrice: mrp > price ? mrp : null,
    badge: Number(item?.discount) > 0 ? `${Math.round(Number(item.discount))}% Off` : null,
    image:         item?.thumbnail,
    gallery:       item?.gallery || [],
    slug:          item?.slug,
    video:         item?.video || null,
  };
}